import { Trans } from '@lingui/react/macro';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import type * as Sentry from '@sentry/react';

import LoginSvg from '@/common-components/elements/icon/svgs/LoginSvg';

const ReturnButton = styled(Button)`
  margin-bottom: 1em;
  text-transform: none;
`;

const ErrorBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FallbackComponent = (
  args: Parameters<Sentry.FallbackRender>[0],
) => {
  return (
    <div className="fallback-component">
      <ErrorBox>
        <h2>
          <Trans>An unexpected error occurred.</Trans>
        </h2>
        <ReturnButton
          onClick={args.resetError}
          variant="outlined"
          color="primary"
          size="small"
        >
          <Trans>Reopen VideaAI and try again?</Trans>
        </ReturnButton>
        <LoginSvg className="logo" viewBox="0 0 120 120" />
      </ErrorBox>
    </div>
  );
};
